import { CardLoader, ListPagination } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import FastSellPaymentTableRow from './fast-sell-payment-table-row'

const propTypes = {
  tableProps       : PropTypes.object,
  fastSellPayments : PropTypes.array,
  pagination       : PropTypes.object,
  onPageChange     : PropTypes.func,
  isLoading        : PropTypes.bool
}

const defaultProps = {
  isLoading    : true,
  onPageChange : () => { }
}

/**
 * Table to display specific ::FastSellPayment columns
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} fastSellPayments - array of fast sell payment objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - boolean for withLoader animation
 * @param {Function} onPageChange - function that will handle page change
 */


const FastSellPaymentTable = ({
  tableProps,
  fastSellPayments,
  pagination,
  isLoading,
  onPageChange
}) => {

  const totalColumns           = 9
  const isFastSellPaymentEmpty = fastSellPayments.length === 0

  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th colSpan={ totalColumns } className='text-center'>
            { 'Fast Sell Payments' }
          </th>
        </tr>
        <tr>
          <th scope="col">id</th>
          <th scope="col">nama produk</th>
          <th scope="col">jumlah</th>
          <th scope="col">bank tujuan</th>
          <th scope="col">no rekening</th>
          <th scope="col">nama pemilik rekening</th>
          <th scope="col">waktu transfer</th>
          <th scope="col">payment status</th>
          <th scope="col">action</th>
        </tr>
      </thead>
      <tbody>
        {
          fastSellPayments.map((fastSellPayment) => (
            <FastSellPaymentTableRow
              key={ `FastSellPayment-${fastSellPayment.id}` }
              fastSellPayment={ fastSellPayment }
            />
          ))
        }
        {
          isFastSellPaymentEmpty && (
            <tr>
              <td
                colSpan={ totalColumns }
                className='bg-warning text-white'
              >
                <i className='fas fa-info-circle mr-3' />
                { 'Fast Sell Payment tidak ditemukan.' }
              </td>
            </tr>
          )
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


FastSellPaymentTable.propTypes    = propTypes
FastSellPaymentTable.defaultProps = defaultProps

export default FastSellPaymentTable
